/* RESPONSIBLE TEAM: team-frontend-tech */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend();
